export default "__VITE_ASSET__ABWEo6X6__"